export const personalizedServingText = (path) =>
  path.includes('siding')
    ? 'Serving Sacramento & Surrounding'
    : 'Serving Sacramento & Surrounding'
